import request from '@/plugins/axios'

// 查询字典分页
export function typePage(data) {
    return request({
        url: '/sys/dict/type/page',
        method: 'post',
        data: data
    })
}

// 查询字典列表
export function typeList(data) {
    return request({
        url: '/sys/dict/type/list',
        method: 'post',
        data: data
    })
}

// 查询字典详细
export function typeDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/dict/type/detail',
        method: 'post',
        data
    })
}

export function typeAdd(data) {
    return request({
        url: '/sys/dict/type/add',
        method: 'post',
        data
    })
}

export function typeUpdate(data) {
    return request({
        url: '/sys/dict/type/update',
        method: 'post',
        data
    })
}

export function typeDeleteForce(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/dict/type/deleteForce',
        method: 'post',
        data
    })
}
